import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@easyflow/ui-frontend/components/ui/dialog';
import { Avatar, AvatarFallback } from '@easyflow/ui-frontend/components/ui/avatar';
import { ScrollArea } from '@easyflow/ui-frontend/components/ui/scroll-area';
import { messengerApi } from '../lib/messengerApi';
import { getAvatarGradient, getInitials } from '../utils/format';
import type { ChatMessage, ConversationSummary } from '../types';

interface Props {
  message: ChatMessage | null;
  conversations: ConversationSummary[];
  currentConversationId: string | null;
  onClose: () => void;
}

// Task #1660 — dialog di inoltro: ripristina parità monolite. Spedisce
// `[Inoltrato da <sender>]: <content>` alla conversazione scelta.
export function ForwardDialog({ message, conversations, currentConversationId, onClose }: Props) {
  const open = !!message;
  const targets = conversations.filter((c) => c.id !== currentConversationId);

  const handlePick = async (targetId: string) => {
    if (!message) return;
    const senderName = `${message.sender_first_name || ''} ${message.sender_last_name || ''}`.trim() || 'Utente';
    await messengerApi.forwardMessage(targetId, senderName, message.content || '');
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent>
        <DialogHeader><DialogTitle>Inoltra messaggio</DialogTitle></DialogHeader>
        <div className="text-sm text-muted-foreground p-3 bg-gray-50 dark:bg-gray-800 rounded-xl border">
          {(message?.content || '').substring(0, 200) || '(allegato)'}
        </div>
        <ScrollArea className="h-64">
          {targets.length === 0 && (
            <p className="text-xs text-muted-foreground text-center py-6">Nessuna altra conversazione disponibile</p>
          )}
          {targets.map((conv) => (
            <button
              key={conv.id}
              type="button"
              className="w-full flex items-center gap-3 p-2.5 rounded-xl hover:bg-accent transition-colors text-left"
              onClick={() => void handlePick(conv.id)}
            >
              <Avatar className="h-8 w-8">
                <AvatarFallback className={`bg-gradient-to-br ${getAvatarGradient(conv.display_title || '')} text-white text-xs font-semibold`}>
                  {conv.type === 'channel' ? '#' : getInitials(conv.display_title?.split(' ')[0], conv.display_title?.split(' ')[1])}
                </AvatarFallback>
              </Avatar>
              <span className="text-sm font-medium truncate">{conv.display_title || 'Conversazione'}</span>
            </button>
          ))}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
